import MenuService from 'live/services/menu'
import i18n from 'live/services/i18n'
import ServiceLocator from 'live/services/service-locator'
import { QualityMonitoringIcon } from './qualityMonitoringIcon'
import Router from 'live/services/router'
import { AssetConfigs } from './assetConfiguration/AssetConfigs'
import { LiveApi } from 'live/lib/api'
import Auth, { LIVE_PERMISSIONS } from 'live/services/authorization'
import { TAB_TYPES } from './qualityMonitoring/tabMenu'
import { FACTORY_CONFIG_ID, PRODUCT_CONFIG_ID, QUALITY_MONITORING_URL } from './common/utils'
import React from 'react'
import ptBr from './i18n/pt_br'
import enUs from './i18n/en_us'
import locale from 'live/init/global-locale'

const userPermissions = Auth.Permission

// Register Factory Configuration
const menuItem = {
    alias: QUALITY_MONITORING_URL,
    selectedAliases: [QUALITY_MONITORING_URL],
    name: i18n('Quality Monitoring'),
    order: 0.5,
    addRoute: true,
    routeUrl: QUALITY_MONITORING_URL,
    url: `/#/${QUALITY_MONITORING_URL}/${TAB_TYPES[0]}`,
    config: {
        showOnMobile: true
    }
}

const tabPath = QUALITY_MONITORING_URL + '/{tab}'
const countryPath = tabPath + '/{country}'
const factoryPath = countryPath + '/{factory}'
const linePath = factoryPath + '/{line}'
const productPath = linePath + '/{product}'
const testTypePath = productPath + '/{testType}'

const QualityMonitoring = React.lazy(() =>
    import('./qualityMonitoring/qualityMonitoring').then(module => ({ default: module.QualityMonitoring }))
)

if (
    userPermissions.isAdmin ||
    userPermissions.QUALITY_OPERATOR ||
    userPermissions.QUALITY_ANALYST ||
    userPermissions.QUALITY_ADMIN
) {
    MenuService.register(menuItem, 'regular')
}
// PLUGIN HOME
Router.route(QUALITY_MONITORING_URL, QualityMonitoring, QUALITY_MONITORING_URL)

// TAB
Router.route(tabPath, QualityMonitoring, QUALITY_MONITORING_URL)

// COUNTRY
Router.route(countryPath, QualityMonitoring, QUALITY_MONITORING_URL)

// FACTORY
Router.route(factoryPath, QualityMonitoring, QUALITY_MONITORING_URL)

// LINE
Router.route(linePath, QualityMonitoring, QUALITY_MONITORING_URL)

// PRODUCT
Router.route(productPath, QualityMonitoring, QUALITY_MONITORING_URL)

// ANALYSIS
Router.route(testTypePath, QualityMonitoring, QUALITY_MONITORING_URL)

// Register Factory Configuration
const factoryDefaultPermissions = [
    LIVE_PERMISSIONS.ADMIN,
    LIVE_PERMISSIONS.MANAGE_STATIC_DATA,
    LIVE_PERMISSIONS.VIEW_STATIC_DATA
]
LiveApi.Extension.configuration.entries.register({
    name: i18n('Factories'),
    area: FACTORY_CONFIG_ID,
    url: '/#/config/' + FACTORY_CONFIG_ID,
    permissions: factoryDefaultPermissions,
    group: 'static-data',
    order: 1,
    addRoute: true,
    routeUrl: FACTORY_CONFIG_ID,
    component: AssetConfigs
})

// Register Product Configuration
const ProductDefaultPermissions = [
    LIVE_PERMISSIONS.ADMIN,
    LIVE_PERMISSIONS.MANAGE_STATIC_DATA,
    LIVE_PERMISSIONS.VIEW_STATIC_DATA
]
LiveApi.Extension.configuration.entries.register({
    name: i18n('Products'),
    area: PRODUCT_CONFIG_ID,
    url: '/#/config/' + PRODUCT_CONFIG_ID,
    permissions: ProductDefaultPermissions,
    group: 'static-data',
    order: 1,
    addRoute: true,
    routeUrl: PRODUCT_CONFIG_ID,
    component: AssetConfigs
})

ServiceLocator.getService('asset-service').then(AssetService =>
    AssetService.types.register({
        name: QUALITY_MONITORING_URL,
        Icon: QualityMonitoringIcon
    })
)

const localeFiles = {
    pt_br: ptBr,
    en_us: enUs
}

i18n.add(localeFiles[locale])
